import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const [first_name, setFirst] = useState("");
  const [last_name, setLast] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email && !phone) { toast.error("Saisissez un email ou un numéro"); return; }
    setLoading(true);
    const { ok, error } = await register({
      first_name, last_name,
      email: email || null,
      phone: phone || null,
      password,
    });
    setLoading(false);
    if (ok) { toast.success("Bienvenue ! Votre compte est créé."); nav("/", { replace: true }); }
    else toast.error(error || "Inscription impossible");
  };

  return (
    <div className="min-h-[80vh] px-4 py-8 max-w-md mx-auto">
      <div className="flex flex-col items-center mb-6">
        <div className="w-14 h-14 rounded-2xl bg-[#E65100] flex items-center justify-center mb-3">
          <span className="text-white font-extrabold text-2xl font-[Manrope]">F</span>
        </div>
        <h1 className="font-[Manrope] font-extrabold text-2xl">Créer un compte</h1>
        <p className="text-sm text-[#73706B] mt-1">Rejoignez la marketplace de la Côte d'Ivoire</p>
      </div>
      <form onSubmit={onSubmit} className="space-y-3" data-testid="register-form">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label>Prénom</Label>
            <Input data-testid="register-first-name" required className="h-12 rounded-xl mt-1" value={first_name} onChange={(e) => setFirst(e.target.value)} placeholder="Ex: Aya" />
          </div>
          <div>
            <Label>Nom</Label>
            <Input data-testid="register-last-name" required className="h-12 rounded-xl mt-1" value={last_name} onChange={(e) => setLast(e.target.value)} placeholder="Ex: Koné" />
          </div>
        </div>
        <div>
          <Label>Email (optionnel)</Label>
          <Input data-testid="register-email" type="email" className="h-12 rounded-xl mt-1" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" />
        </div>
        <div>
          <Label>Téléphone (optionnel)</Label>
          <Input data-testid="register-phone" type="tel" className="h-12 rounded-xl mt-1" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+225 07 00 00 00 00" />
        </div>
        <div>
          <Label>Mot de passe</Label>
          <Input data-testid="register-password" required type="password" minLength={6} className="h-12 rounded-xl mt-1" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="6 caractères minimum" />
        </div>
        <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-[#E65100] hover:bg-[#C44100] text-white font-bold mt-2">
          {loading ? "Création…" : "Créer mon compte"}
        </Button>
      </form>
      <div className="mt-4 text-center text-sm">
        <span className="text-[#73706B]">Déjà inscrit ? </span>
        <Link to="/connexion" className="font-semibold text-[#E65100]">Se connecter</Link>
      </div>
    </div>
  );
}
